/**
 * Created by seven on 2018/4/26.
 */

export default {
  messages: {
    alpha: () => 'Some English Message',
    email: () => '請輸入正確的 Email 信箱',
    required: (value) => value + ' 必填，不能為空',
    min: (value, length) => value + ' 最小長度為 ' + length,
    max: (value, length) => value + ' 字數最多 ' + length + ' 個字元',
    min_value: (value, length) => value + ' 最小值為 ' + length,
    max_value: (value, length) => value + ' 最大值為 ' + length,
    numeric: (value) => value + ' 必須為整數',
    decimal: (value, length) => value + ' 小數點位數長度最大為 ' + length,
    customNumeric: (value) => '請輸入正確數字 (0.5為單位，小數點一位)',
    customVerifyAfterDate: (value) => value + ' 日期範圍不正確',
    no_space: (value) => value + ' 不能輸入空格',
    customTime: (value) => value + ' 開始時間必須早於結束時間',
    url: (value) => '不正確的連結網址',
    mobileTaiwan: (value) => '手機號碼不符合格式',
    date_format: (value) => '日期不符合格式 (YYYY/MM/DD)',
    customStrLen: (value, length) => value + ' 不能超過 ' + (length / 2) + ' 個中文字（' + length + '個英數字）',
    checkDateRepeat: (value) => '使用日期不能重疊，請重新設定啟用時間',
    maxArrLen: (value, length) => value + ' 最大數量為 ' + length,
    minArrLen: (value, length) => value + ' 最小數量為 ' + length,
    validateHttpsUrl: () => '請以 https:// 為開頭',
    phoneCode: (value) => value + ' 不符合格式',
    naturalCode: (value) => value + ' 不符合格式',
    loveCode: (value) => value + ' 不符合格式',
    taxNumber: (value) => value + ' 不符合格式',
    customPhoneNum: (value) => '格式錯誤',
    customEmail: (value) => '格式錯誤，只允許字母、數字、底線 (_) 和點號 (.)',
    brand: (value) => '格式錯誤',
    customPassword: (value) => '格式錯誤',
    customPasswordLen: (value) => '格式錯誤',
    is: (value) => value + ' 與密碼不符'
  }
}
